import React, { FC, useState, useEffect, memo } from "../../../lib/teact/teact";
import Button from "../../ui/Button";
import { updateDonViTien } from "../redux/contactsSlice";
import store from "../store";
import Snackbar from "../ui/snackbar";
import "./donViTien.scss";
import _ from "lodash";
interface IDonViTien {
    contactId: number,
    uSetValue: string,
    heSoToBase: number,
}
type OwnProps = {
    donViTien: IDonViTien[],
    showSaveButton?: boolean,
    onSaveData?: (data: IDonViTien[]) => void,
    allowAddRemove?: boolean,
}
const DonViTien: FC<OwnProps> = ({
    donViTien,
    showSaveButton = false,
    onSaveData,
    allowAddRemove = true,
}) => {
    const [state, setState] = useState({
        donViTien: donViTien,
        showSnackbar: false,
        snackbarText: "",
    })
    useEffect(() => {
        // Fetch data from API or perform any other side effects here
    }, [])
    function handleRemoveItem(index: number) {
        const tmp = [...state.donViTien]
        tmp.splice(index, 1)
        setState((prev: any) => ({ ...prev, donViTien: tmp }))
        store.dispatch(updateDonViTien({ donViTien: tmp }))
    }
    function handleAddItem() {
        const contact: any = store.getState().contact.currentContact;
        if (contact == null) {
            setState((prev: any) => ({ ...prev, showSnackbar: true, snackbarText: "Chưa chọn liên hệ" }))
            return
        }
        const newItem = {
            uSetValue: "",
            hsToBase: 1,
            contactId: contact.contactId,

        }
        const found = state.donViTien.filter((record: any) => {
            let notOk = true
            notOk = record.uSetValue == newItem.uSetValue
            notOk = notOk || record.uSetValue == ''

            return notOk
        })
        if (found.length == 0) {
            const tmp = [...state.donViTien]
            tmp.push(newItem)
            setState((prev: any) => ({ ...prev, donViTien: tmp }))
            //const element = document.getElementById(`dvt-${tmp.length - 1}`)
            //element?.scrollIntoView({ behavior: 'smooth' })
        }

    }
    useEffect(() => {
        const element = document.getElementById(`dvt-${state.donViTien.length - 1}`)
        element?.scrollIntoView({ behavior: 'smooth' })
    }, [state.donViTien])
    function handleDvtChange(index: number, e: any) {
        const tmp = _.cloneDeep(state.donViTien)
        const record = tmp[index]
        record.uSetValue = e.target.value
        tmp[index] = record
        setState((prev: any) => ({ ...prev, donViTien: tmp }))
        store.dispatch(updateDonViTien({ donViTien: tmp }))
    }
    function handleHeSoChange(index: number, e: any) {
        const tmp = _.cloneDeep(state.donViTien)
        const record = tmp[index]
        const value = Number(e.target.value);
        if (!isNaN(value)) {
            record.heSoToBase = value
            tmp[index] = record
            setState((prev: any) => ({ ...prev, donViTien: tmp }))
            store.dispatch(updateDonViTien({ donViTien: tmp }))
        }

    }
    function handleSaveData() {

    }
    return (
        <div className="donViTien-main">
            <div className="donViTien-header">
                <div className="header">
                    Đơn vị tiền
                </div>
                <div className="header">
                    Hệ số quy ra n
                </div>
                <div className="right-panel">
                    {allowAddRemove &&
                        <>
                            <Button round color="translucent" size="smaller"
                                onClick={() => handleRemoveItem(-1)}
                            >
                                <i className="icon icon-remove" />
                            </Button>

                            <Button round color="translucent" size="smaller"
                                onClick={handleAddItem}
                            >
                                <i className="icon icon-add" />
                            </Button>
                        </>
                    }
                    {showSaveButton &&
                        <Button round color="translucent" size="smaller"
                            onClick={handleSaveData}
                        >
                            <i className=" fa-solid fa-floppy-disk" />
                        </Button>
                    }
                </div>

            </div>
            {
                state.donViTien.map((record: IDonViTien, index: number) => {
                    return (
                        <div className="donViTien-container" key={`${index}`} id={`dvt-${index}`}>
                            <input className="input" value={record.uSetValue}
                                onChange={(e) => handleDvtChange(index, e)}
                            >

                            </input>
                            <input className="input" value={record.heSoToBase}
                                onChange={(e) => handleHeSoChange(index, e)}
                            >

                            </input>
                            <div className="right-panel">
                                {allowAddRemove &&
                                    <Button round color="translucent" size="smaller"
                                        onClick={() => handleRemoveItem(index)}

                                    >
                                        <i className="icon icon-remove" />
                                    </Button>
                                }

                            </div>
                        </div>

                    )
                })
            }
            <Snackbar isOpen={state.showSnackbar} message={state.snackbarText}
                triggerTime="3000"
                onClose={() => setState(prev => ({ ...prev, showSnackbar: false }))}>
            </Snackbar>
        </div>
    )
}
export default memo(DonViTien)